import { IGift } from "@interfaces/user/daily";
import { createContext, useContext } from "react";

export const DailyGiftContext = createContext<IGift>(undefined as any);
export const DailyGiftProvider = DailyGiftContext.Provider;

export function useDailyGiftContext(): IGift | undefined {
    return useContext(DailyGiftContext);
}
